import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, prevUrl: String, nextUrl: String }

  open(event) {
    event.preventDefault()
    // Capture values before #updateNavButton may mutate data attributes on this
    // element (when this button is itself one of the nav buttons in the slideover).
    const url = this.urlValue
    const prevUrl = this.prevUrlValue
    const nextUrl = this.nextUrlValue
    if (!url) return

    const slideoverEl = document.getElementById("entry-preview-slideover")
    if (!slideoverEl) return

    const slideoverCtrl = this.application.getControllerForElementAndIdentifier(slideoverEl, "slideover")
    if (!slideoverCtrl) return

    this.#updateNavButton(slideoverEl, "prev", prevUrl)
    this.#updateNavButton(slideoverEl, "next", nextUrl)
    this.#highlightActiveRow(url, slideoverEl)

    // Set up the Turbo Frame before opening — dialog shows immediately while
    // Turbo loads content asynchronously into the visible frame.
    const container = slideoverEl.querySelector("[data-slideover-content]")
    if (container) {
      let frame = container.querySelector("turbo-frame")
      if (!frame) {
        frame = document.createElement("turbo-frame")
        frame.id = "slideover-lazy-content"
        container.appendChild(frame)
      }
      frame.innerHTML = ""
      frame.src = url
    }

    const approvalFrame = slideoverEl.querySelector("turbo-frame#slideover-approval-actions")
    if (approvalFrame) {
      approvalFrame.innerHTML = ""
      approvalFrame.src = url
    }

    slideoverCtrl.show(event)
  }

  #highlightActiveRow(url, slideoverEl) {
    document.querySelector("tr.preview-active")?.classList.remove("preview-active")

    const sourceBtn = document.querySelector(
      `[data-controller~="entry-preview-trigger"]:not([data-nav])[data-entry-preview-trigger-url-value="${url}"]`
    )
    const row = sourceBtn?.closest("tr")
    if (!row) return

    row.classList.add("preview-active")

    const dialog = slideoverEl.querySelector("dialog")
    dialog?.addEventListener("close", () => row.classList.remove("preview-active"), { once: true })
  }

  #updateNavButton(slideoverEl, nav, url) {
    const btn = slideoverEl.querySelector(`[data-nav="${nav}"]`)
    if (!btn) return
    if (url) {
      // Look up the list button for this URL to carry its prev/next chain forward
      const sourceBtn = document.querySelector(
        `[data-controller~="entry-preview-trigger"]:not([data-nav])[data-entry-preview-trigger-url-value="${url}"]`
      )
      btn.dataset.entryPreviewTriggerUrlValue = url
      btn.dataset.entryPreviewTriggerPrevUrlValue = sourceBtn?.dataset.entryPreviewTriggerPrevUrlValue ?? ""
      btn.dataset.entryPreviewTriggerNextUrlValue = sourceBtn?.dataset.entryPreviewTriggerNextUrlValue ?? ""
      btn.disabled = false
    } else {
      btn.dataset.entryPreviewTriggerUrlValue = ""
      btn.dataset.entryPreviewTriggerPrevUrlValue = ""
      btn.dataset.entryPreviewTriggerNextUrlValue = ""
      btn.disabled = true
    }
  }
}
